import { GeneralSettingApi, SeoApi } from '@/apis';
import RootStore from '.';
import { flow, makeObservable } from 'mobx';
import BaseStore from './BaseStore';
import { ResponseData } from '@/types/http';
import {
    GetGeneralSettingRequest,
    GetGeneralSettingResponse,
    GetSeoResponse,
    UpdateGeneralSettingRequest,
    UpdateGeneralSettingResponse
} from '@/types/http-payload/forum';
import { GeneralSettingType } from '@/types/enums';
import BannerApi from '@/apis/Banner';

export default class GeneralSettingStore extends BaseStore {
    api: GeneralSettingApi;
    apiSeo: SeoApi;
    bannerApi: BannerApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            updateGereralSettingByType: flow.bound,
            getGereralSettingByType: flow.bound,
            getSeoCms: flow.bound,
            updateSeoCms: flow.bound,
            getPresignedUrl: flow.bound,
            getBanner: flow.bound,
            updateBanner: flow.bound
        });
        this.api = new GeneralSettingApi();
        this.apiSeo = new SeoApi();
        this.bannerApi = new BannerApi();
    }

    *updateGereralSettingByType(payload: UpdateGeneralSettingRequest) {
        try {
            const res: ResponseData<UpdateGeneralSettingResponse> = yield this.rootStore.apiStore.call(
                this.api,
                this.api.updateGereralSettingByType,
                payload
            );
            if (res?.ok) {
                return true;
            }
            return false;
        } catch (error) {
            return false;
        }
    }

    *getGereralSettingByType(type: GeneralSettingType) {
        try {
            const res: ResponseData<GetGeneralSettingResponse> = yield this.rootStore.apiStore.call(
                this.api,
                this.api.getGereralSettingByType,
                type
            );
            return res?.data?.value ?? '';
        } catch (error) {
            return false;
        }
    }

    *getSeoCms(type: string, entityId: string) {
        try {
            const res: ResponseData<GetSeoResponse> = yield this.rootStore.apiStore.call(
                this.apiSeo,
                this.apiSeo.getSeoCms,
                { type, entityId }
            );
            return res;
        } catch (error) {
            return false;
        }
    }

    *updateSeoCms(type: string, entityId: string, payload: any) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(this.apiSeo, this.apiSeo.updateSeoCms, {
                type,
                entityId,
                payload
            });
            return res;
        } catch (error) {
            return false;
        }
    }

    *getPresignedUrl(files: { name: string, type: string }[]) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(
                this.apiSeo,
                this.apiSeo.getPresignedUrl,
                { files }
            );
            return res?.data ?? '';
        } catch (error) {
            return false;
        }
    }

    *getBanner() {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(
                this.bannerApi,
                this.bannerApi.getBanner,
                undefined
            );
            if (res?.ok) {
                return res.data;
            }
        } catch (error) { }
    }

    *updateBanner(payload) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(
                this.bannerApi,
                this.bannerApi.update,
                payload
            );
            if (res?.ok) {
                return true;
            }
        } catch (error) {
            return false;
        }
    }

    clean(): void {
        super.clean();
    }
}
